module.exports = __webpack_public_path__ + "img/angle_315.85b4fb31.jpg";